import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const FormContainer = styled.form`
    min-width: 100%;
    flex-direction: column;
    margin-top: 120px;
    display: flex;
    gap: 25px;
    margin-bottom: 70px;
`;